import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageItemDiff } from '@/api/model/interfaces';

export default class DrawingPackageItemDiffOdata extends OdataManager<DrawingPackageItemDiff> {}
